// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf /*, maybe */ } from "@altostra/type-validations";
import { any, number, string } from "@altostra/type-validations/lib/primitives";

export const isCompanySettingsMostUsedEventsAndAttributesByAppsAndAppGroupsResult = objectOf({
  app_name: string,
  app_group_name: string,
  app_group_image_url: string,
  top_n_data_points: arrayOf(objectOf({ any })),
  top_n_custom_attribute_data_points: objectOf({ any }),
  top_profile_attribute_data_points: objectOf({ any }),
  top_n_custom_event_data_points: objectOf({ any }),
  platform: string,
  data_points_n_days: number,
});
